export const ConnectionState = Object.freeze({
  CONNECTED: 'connected',
  RECONNECTING: 'reconnecting',
  OFFLINE: 'offline'
})

const listeners = new Set()
let currentState = ConnectionState.CONNECTED

export const connectionManager = {
  getState: () => currentState,

  setState(next) {
    if (next === currentState) return
    currentState = next
    listeners.forEach(fn => fn(next))
  },

  subscribe(listener) {
    listeners.add(listener)
    return () => listeners.delete(listener)
  }
}
